import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { OrderTemplate } from "./OrderTemplate";
import { OrderApi } from "../../app/api/order.api";
import { formatDateTime } from "./OrderTemplateComponenent";


export default function PendingOrder() 
{
 
  const order = OrderApi();
  const [date, setDate] = useState("");
  const [ref, setRef] = useState("ORD-");
  const [filteredData, setFilteredData] = useState([]);
    
  const fetchData = async () => { 
    const {data} = await order.findAll('pending');
    return data.data; 
  }
  const { isLoading, data=[], error } = useQuery({  queryKey: ["pendingOrders"], queryFn: fetchData });
  
  useEffect(() => {
    
      if (!Array.isArray(data)) return;
      let filtered = data;
    
      if (date) filtered = filtered.filter(item => item.updatedAt?.toLowerCase().startsWith(date.toLowerCase()) );
      if (ref) filtered = filtered.filter(item => item.ref?.toLowerCase().startsWith(ref.toLowerCase()) );
 
      setFilteredData(filtered);
    
  }, [data, date, ref]);  


  return (

    <OrderTemplate page={1} >

      <div className="col-lg-12 mb-4">
        {/* Header background */}
        <div className="card border rounded-top-0 px-3">
          <div className="d-flex flex-wrap justify-content-between align-items-center py-3 gap-2">
            <div className="d-flex align-items-center gap-2">
              <i className="bi bi-funnel text-muted"></i>
              <span className="text-secondary"> Filtre : { filteredData.length } effectif(s) </span>
            </div>
            <div className="d-flex flex-wrap align-items-center gap-2">
              <input type="month" name="month" className="border px-3 py-1 text-secondary" onChange={ e => setDate(e.target.value) } />
              {/* SEARCH BAR */}
              <div className="d-flex align-items-center">
                <input type="search" className="w-100 px-3 py-1 border text-secondary" placeholder="Rechercher une commande..." name="ref" value={ref} onChange={ e => setRef(e.target.value) } />
                <span className="border py-1 px-2"> <i className="bi bi-search text-muted"></i> </span>                 
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-12">
      {
          isLoading ? (
              <div className="d-flex flex-column align-items-center gap-3">
                <div className="spinner-border text-green mb-3" style={{ width: '6rem', height: '6rem' }}></div>
                <p className="text-secondary"> Chargement en cours... </p>
              </div>
            )  : (
      
        ( Array.isArray(data) && data.length > 0 ) &&
        
          filteredData.map( ( item, index ) => (

            <div className="border product-card bg-white text-secondary rounded-3 mb-4 mt-2" key={index}>
              
                <div className="d-flex flex-column border-bottom px-4 py-3 mt-2">
                  <div className="d-flex align-items-center">    
                     <span className="text-secondary py-2 border px-3 bg-light h6"> 
                       <i className="bi bi-clock me-2"></i> Ref commande : 
                     </span>
                     <span className="text-secondary py-2 px-3 mb-1"> { item.ref } </span>
                  </div>  
                  <span className="text-secondary small"> Date : { formatDateTime( item.updatedAt) } </span>   
                </div>  
                <div className="d-flex flex-column flex-md-row gap-3 px-4 py-3">
                  <a className={`btn btn-sm py-2 px-3 btn-dark`} href={`/commande/${item.id}`}> 
                    Consulter <i className="bi bi-box-arrow-up-right ms-2"></i>
                  </a>
                  <div className="d-flex align-items-center border">    
                     <span className="text-secondary py-2 px-3 bg-light fw-bold border-end"> 
                       <i className="bi bi-grid-fill me-2"></i> Montant total :  
                     </span>
                     <span className="text-secondary py-2 px-3"> { item.amount }  </span>
                     <span className="text-secondary py-2 px-3 bg-light border-start"> FCFA  </span>
                  </div>   
                </div> 
            </div>

          )
        
        ) 
        )
      }  
      {
        error && ( 
            <div className="text-center p-4 border alert alert-danger w-100">
              Une erreur est survenue. Vueiller vérifier votre connexion 
            </div>
        )
      }
      </div>

    </OrderTemplate>
  );
}
